'use client';

import { c as _c } from "react/compiler-runtime";
import { memo, type ReactNode, Suspense } from 'react';
import { CardDashboardLayout } from '@/components/common/Card/CardDashboard';
import SectionErrorBoundary from '@/components/common/SectionErrorBoundary';
import { useDashboardContext } from '@/contexts/Dashboard/Dashboard.context';
import { BorrowDashboardCardApySkeleton, BorrowDashboardCardChartSkeleton } from '../BorrowDashboardCard';
import { BorrowApyCardError } from './BorrowApyCard';
import { ChartMyBorrowError } from './ChartMyBorrow';
export interface DashboardCardProps {
  chartMyBorrowSlot: ReactNode;
  netBorrowApySlot: ReactNode;
}
const DashboardCard = t0 => {
  const $ = _c(20);
  const {
    chartMyBorrowSlot,
    netBorrowApySlot
  } = t0;
  const {
    isDashboardExpanded,
    isDashboardHovered,
    isSmallDashboard,
    setIsDashboardHovered,
    onClickToggleDashboard
  } = useDashboardContext();
  let t1;
  let t2;
  if ($[0] !== setIsDashboardHovered) {
    t1 = () => setIsDashboardHovered(true);
    t2 = () => setIsDashboardHovered(false);
    $[0] = setIsDashboardHovered;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ChartMyBorrowError />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <BorrowDashboardCardChartSkeleton />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== chartMyBorrowSlot) {
    t5 = <SectionErrorBoundary fallback={t3}><Suspense fallback={t4}>{chartMyBorrowSlot}</Suspense></SectionErrorBoundary>;
    $[5] = chartMyBorrowSlot;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <BorrowApyCardError />;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <BorrowDashboardCardApySkeleton />;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== netBorrowApySlot) {
    t8 = <SectionErrorBoundary fallback={t6}><Suspense fallback={t7}>{netBorrowApySlot}</Suspense></SectionErrorBoundary>;
    $[9] = netBorrowApySlot;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== isDashboardExpanded || $[12] !== isDashboardHovered || $[13] !== isSmallDashboard || $[14] !== onClickToggleDashboard || $[15] !== t1 || $[16] !== t2 || $[17] !== t5 || $[18] !== t8) {
    t9 = <CardDashboardLayout isExpanded={isDashboardExpanded} isSmall={isSmallDashboard} isHovered={isDashboardHovered} onMouseEnter={t1} onMouseLeave={t2} onClick={onClickToggleDashboard} chartMyDepositsSlot={t5} earnApyCardSlot={t8} />;
    $[11] = isDashboardExpanded;
    $[12] = isDashboardHovered;
    $[13] = isSmallDashboard;
    $[14] = onClickToggleDashboard;
    $[15] = t1;
    $[16] = t2;
    $[17] = t5;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
};
export default memo(DashboardCard);